import React, { useState, useEffect } from 'react';
import '../styles/wallettransaction.css';

function WalletTransaction() {

    const [selectedTab, setSelectedTab] = useState("deposit");
    const [isLoading, setIsLoading] = useState(true);
    const [transactions, setTransactions] = useState([]);
    const [error, setError] = useState(null);
    const [visibleButtons, setVisibleButtons] = useState(3); // Number of visible buttons  
    const totalButtons = 4;
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
            try {
                const user = JSON.parse(storedUser);
                setUserData(user);
            } catch (error) {
                console.error("Error parsing user data:", error);
                setError("Failed to retrieve user data.");
            }
        }
    }, []);

    useEffect(() => {
        const fetchTransactions = async () => {
            if (!userData || !userData.username) {
                setError("Username is not available.");
                setIsLoading(false);
                return;
            }

            setIsLoading(true);
            const encodedUsername = encodeURIComponent(userData.username);
            const baseUrl = process.env.REACT_APP_API_BASE_URL;
            let url = `${baseUrl}/transactions/${selectedTab}/${encodedUsername}`;

            console.log("Request URL:", url);

            try {
                const response = await fetch(url);
                const data = await response.json();

                if (response.ok) {
                    setTransactions(data);
                } else if (response.status === 404) {
                    setTransactions([]); // No transactions found, so set an empty array
                } else {
                    setError(data.message || "Failed to fetch transactions.");
                }
            } catch (err) {
                setError("An error occurred while fetching transactions.");
            } finally {
                setIsLoading(false);
            }
        };

        if (userData && userData.username) {
            fetchTransactions();
        }
    }, [selectedTab, userData]);

    const filteredTransactions = transactions.filter(transaction => {
        if (selectedTab === "allhistory") return true; // Show all transactions
        if (selectedTab === "deposit") return transaction.type === "deposit";
        if (selectedTab === "withdrawal") return transaction.type === "withdraw";
        if (selectedTab === "defistaking") return transaction.type === "defistaking";
        return false;
    });




    const showLessButtons = () => {
        setVisibleButtons(prev => Math.max(prev - 1, 1)); // Decrease visible buttons, min 1  
    };

    return (
        <div className="transaction-history-page">
            <div className="history-container">
                <div className="history-tab-container">
                    {["deposit", "withdrawal", "defistaking", "allhistory"].map(tab => (
                        <button
                            key={tab}
                            className={`history-button ${selectedTab === tab ? "active" : ""}`}
                            onClick={() => setSelectedTab(tab)}
                            aria-label={`Show ${tab.charAt(0).toUpperCase() + tab.slice(1)}`}
                        >
                            {tab.toUpperCase()}
                        </button>
                    ))}

                </div>

                <div className="history-container">
                    {isLoading ? (
                        <p className="loading">Loading...</p>
                    ) : error ? (
                        <p className="error">{error}</p>
                    ) : (
                        <table className="row-table">
                            <thead>
                                <tr>
                                    <th>Amount</th>
                                    <th>Duration</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredTransactions.length > 0 ? (
                                    filteredTransactions.map((transaction, index) => (
                                        <tr key={index}>
                                            <td>{parseFloat(transaction.amount).toLocaleString()}</td>
                                            <td>
                                                <div className="date-time-stack">
                                                    {transaction.date ? (
                                                        <>
                                                            <span>{new Date(transaction.date).toLocaleDateString()}</span>
                                                            <span>{new Date(transaction.date).toLocaleTimeString()}</span>
                                                        </>
                                                    ) : (
                                                        "N/A"
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <button
                                                    className={`status-button ${transaction.status === 'pending' ? 'status-pending' : ''}`}
                                                >
                                                    {transaction.status}
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3">No transactions available for this tab.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}

export default WalletTransaction;